export class UserWorklistRequest {
    module: string;
    viewType: 'all' | 'created' | 'approver' | 'allMessages' | 'myMessages' | 'pendingMyApproval';
    userId: string;
    userEmail?: string;

    constructor(module: string = '', viewType: 'all' | 'created' | 'approver' | 'allMessages' | 'myMessages' | 'pendingMyApproval' = 'all', userId: string = '', userEmail?: string) {
        this.module = module;
        this.viewType = viewType;
        this.userId = userId;
        this.userEmail = userEmail;
    }
}
